import { withNamespaces } from 'react-i18next'
import { connect } from 'react-redux'
import axios from 'axios'
import Spinner from 'react-bootstrap/Spinner'
import { downloadCSVTemplate } from '../../api/apiFunctions';
import { toast } from 'react-toastify'
import { useState } from 'react'

const DownloadTemplateButton = ({ 
    t, 
    token,
    modules: {
        active: activeModule
    }
}) => {
    const [templateDownloadOptions, setTemplateDownloadOptions] = useState({
        percent: 0,
        status: null,
        cancelToken: null
    })

    const handleDownloadTemplate = async () => {
        const cancelToken = axios.CancelToken.source()

        setTemplateDownloadOptions({
            percent: 0,
            status: 'downloading',
            cancelToken: cancelToken
        })

        let loadedBytes = 0

        try {
            const response = await downloadCSVTemplate({
                onDownloadProgress: (progressEvent) => {
                    loadedBytes = progressEvent.loaded

                    const percentCompleted = Math.round(
                        (loadedBytes * 100) / progressEvent.total
                    )

                    setTemplateDownloadOptions((currentState) => {
                        return {...currentState, percent: percentCompleted}
                    })
                },
                cancelToken: cancelToken.token,
                activeModule,
                token
            })
    
            const url = window.URL.createObjectURL(
                new Blob([response.data], { type: '*' })
            )

            const link = document.createElement('a')
    
            link.href = url
            link.setAttribute('download', 'users_csv_template.csv')
    
            document.body.appendChild(link)
    
            link.click()
            link.remove()

            setTemplateDownloadOptions({
                percent: 0,
                status: 'finished',
                cancelToken: null
            })
        } 
        catch (error) {
            let status;
            if (axios.isCancel(error)) {
                status = 'canceled'
                toast(t('Download cancelled.'), {
                    type: 'success',
                })
            } 
            else {
                status = 'faild'
                toast(t('An error occurred while downloading the file.'), {
                    type: 'error'
                })
            }

            setTemplateDownloadOptions({
                percent: 0,
                status: status,
                cancelToken: null
            })
        }
    }

    return (
        <div
            onClick={handleDownloadTemplate}
        >
            {templateDownloadOptions.status === 'downloading' ? (
                <>
                    <Spinner
                        animation='border'
                        variant='primary'
                        size='sm'
                        className='me-1'
                    />
                    {t('Downloading')}{` ${templateDownloadOptions.percent}%`}
                    
                </>
            ) : (
                <>
                    <i className='ri-download-line align-middle me-1' />
                    {t(
                        'Download CSV Template'
                    )}
                </>
            )}
        </div>
    )
}

const mapToState = (state) => {
    const { token } = state.Login
    const { Modules } = state

    return {
        token,
        modules: Modules
    }
}

export default withNamespaces()(
    connect(mapToState, {})(
        DownloadTemplateButton
    )
)